
import "../css/platform.css";

import "../css/general.css";
import "../css/Coaching.css"; // Imports like this require WebPack! (create-react-app uses WebPack)
// TODO ^^^^^^^^^^^^^^^^^^^^^^ - Move out the "Course" part to "Course.css" ????
//               OR NAHHHHH  -- Since this is Program.tsx w/ all related mushed in...
//              ... Or should even this be separated out a bit more -- PROBABLY...


/* TODOs:
- Improve CSS naming throughout -- And optimize for REUSE (e.g. all DropDownSelector Wrappers/Configs have own CSS Classes) -- DO SAME FOR Program.tsx ...

*/

import { SyntheticEvent, useEffect, useState, useCallback, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

import { fromCamelCaseToCapitalizedSpaced, fromKebabCaseToCamelCase, toCamelCase } from "../utilities/helpers";
//import { fetchVideoURL } from "../utilities/server-fetch"; // TODO: May want use for a video of me speaking to camera (?)


import { Header } from "./../common/Header";
import { HamburgerMenu,  FeatureComingSoon, LockIcon, GeneralLockedContentContainer, LogInPromptContainer } from "../common/Components";

import { EngagementTypeSelector, ProgramSelector, TimeUnits, TimeService, SubjectSelector } from "@Beasted1010/pivotal-wisdom";

import { useHash, useQuery } from "../utilities/location";
import { useUser } from "../context/UserContext";

import { CoachingContextProvider } from "../context/CoachingContext";
import { useCoaching, useCoachingUpdate } from "../context/CoachingContext";

import { CoachingScheduleContextProvider } from "../context/CoachingScheduleContext";
import { useCoachingSchedule, useCoachingScheduleUpdate } from "../context/CoachingScheduleContext";

import { CoachingTestimonialsContextProvider } from "../context/CoachingTestimonialsContext";
import { useCoachingTestimonials, useCoachingTestimonialsUpdate } from "../context/CoachingTestimonialsContext";

import { CoachingAppointmentModalContextProvider, useCoachingAppointmentModalContext, useCoachingAppointmentModalContextUpdate } from "../context/CoachingAppointmentModalContext";

import { fetchCoachingAvailability } from "../utilities/server-fetch";
import { reportInteraction } from "../utilities/server-update-analytics";

import * as Socials from "../common/SocialIcons";




enum AppointmentType { // TODO: Duplicated (e.g. CoachingScheduleContext.tsx)
  RECURRING = "Recurring",
  ADHOC = "Adhoc",
}



type CoachingParams = {
  engagementSelector: EngagementTypeSelector;
  optionSelector: string; // TODO: Consider making this an Enum??
}


function Coaching() {

  const [ searchParams ] = useSearchParams();

  /*
  const urlQuery = useQuery();

  console.log("URL QUERY...");
  console.log( urlQuery );
  */

  /*
  const subject = fromKebabCaseToCamelCase(searchParams.get("subject") as string) as SubjectSelector;
  const program = fromKebabCaseToCamelCase(searchParams.get("program") as string) as ProgramSelector;
  const service = fromKebabCaseToCamelCase(searchParams.get("service") as string);

  console.log( subject, program, service );
  */

  /*
  const urlHash = useHash();

  if( urlHash == "" || urlHash == null ) { // TODO: ERROR HANDLE -- Figure out proper check (i.e. is it undefined?)
    console.log("NO HASH, default to first?");
  }

  let item = fromKebabCaseToCamelCase( urlHash );
  */

  const params = useParams<CoachingParams>();
  if( !params.engagementSelector || !params.optionSelector ) return null;//<></>;

  const engagementSelector = fromKebabCaseToCamelCase( params.engagementSelector ) as EngagementTypeSelector;
  const optionSelector = fromKebabCaseToCamelCase( params.optionSelector ) as string;

  return (
    <>
      {/*</><CoachingContextProvider engagementSelector={engagementSelector} optionSelector={optionSelector} subject={subject} program={program} service={service} >*/}
      <CoachingContextProvider engagementSelector={engagementSelector} optionSelector={optionSelector} >
        {/* TODO: Consider independent-izing Header cuz ProgramContext now wraps RibbonCntext per React Profiler ... BUT need Program Name and Program Heading some way...*/}
        <Header content={<HeaderContent />} />

        <Main />
      </CoachingContextProvider>
    </>
  );
}


function HeaderContent() {

  const { coachingData } = useCoaching();

  if( coachingData == null ) return <></> // TODO: ERROR HANDLING

  return (
    <div className="platform_page_header_container">
      <div className="platform_page_header_content">
        <h1 className="platform_page_header_heading">{coachingData.name}</h1>
        <p className="platform_page_header_slogan">
          {coachingData.heading}
        </p>
      </div>
    </div>
  );
}


function Main() {

  return (
    <main className="platform_body coaching_body">

      <Overview />

      <Engagement />

    </main>
  );
}


/* =========================== Overview =========================== */
function Overview() {
  return (
    <div className="platform_aside_container">
      <Navigation />

      <EngagementOverview />
    </div>
  );
}

function Navigation() {
  // TODO: Enforce Structure ... via <Generics>
  const { coachingData, selectedEngagement } = useCoaching();
  const { selectEngagement } = useCoachingUpdate();

  if( coachingData == null ) return <></> // TODO: ERROR HANDLE

  return (
    <div className="platform_aside_nav_container">
      <HamburgerMenu />

      <select onChange={(e) => selectEngagement(toCamelCase(e.target.value))} value={selectedEngagement} className="platform_aside_nav_dropdown electric-ultramarine-shadow">
        {coachingData.engagements.map( (engagement: IEngagement, index: number) => {
          return <NavigationOption name={engagement.name} selector={engagement.selector} key={engagement.selector} />
        })}

        <option value="MoreToCome" disabled>... More to Come! ...</option>
      </select>
    </div>
  );
}

type NavigationProps = {
  name: string;
  selector: any;//FeatureTypeSelector;
}
function NavigationOption( {name, selector}: NavigationProps ) { // TODO: Move to generic file cuz Program.tsx AND Coaching.tsx seem to overlap in use
  return (
    <option value={selector} className="platform_aside_nav_dropdown_option">
      {name}
    </option>
  );
}

/*
function ContentOverviewFreeText( {text="FREE"}: {text?: string} ) {
  return (
    <span className="content-overview-free-text">{text}</span>
  )
}
*/




/* =========================== Engagement =========================== */

function EngagementOverview() {

  const { selectedEngagement } = useCoaching(); // TODO: TYPE-IT
  if( selectedEngagement == null ) return <></>; // TODO: Proper Error Handle ??

  return (
    <>
      {renderEngagementSwitch(selectedEngagement, EngagementAspect.OVERVIEW)}
    </>
  )
}

function Engagement() {
  const { selectedEngagement } = useCoaching(); // TODO: TYPE-IT
  if( selectedEngagement == null ) return <></>; // TODO: Proper Error Handle ??

  return (
    <div className="platform_content_card">
      {renderEngagementSwitch(selectedEngagement, EngagementAspect.CONTENT)}
    </div>
  );
}



enum EngagementAspect { // TODO: Move this (and FeatureAspect in Program.tsx) to Shared Repo (enums.ts - types)
  OVERVIEW = "overview",
  CONTENT = "content",
}
function renderEngagementSwitch( selectedEngagement: EngagementTypeSelector, engagementAspect: EngagementAspect ) {
  switch( toCamelCase(selectedEngagement) ) {
    case EngagementTypeSelector.SCHEDULE:
      return (
        <CoachingScheduleContextProvider>
          {engagementAspect == EngagementAspect.OVERVIEW ? <ScheduleOverview /> : <ScheduleContent />}
        </CoachingScheduleContextProvider>
      );
      break;

    case EngagementTypeSelector.OFFERS:
      return engagementAspect == EngagementAspect.OVERVIEW ? <OffersOverview /> : <OffersContent />;
      break;

    case EngagementTypeSelector.PORTFOLIO:
      return engagementAspect == EngagementAspect.OVERVIEW ? <PortfolioOverview /> : <PortfolioContent />;
      break;

    case EngagementTypeSelector.TESTIMONIALS:
      return (
        <CoachingTestimonialsContextProvider>
          {engagementAspect == EngagementAspect.OVERVIEW ? <TestimonialsOverview /> : <TestimonialsContent />}
        </CoachingTestimonialsContextProvider>
      );
      break;

    case EngagementTypeSelector.CONTACT:
      return engagementAspect == EngagementAspect.OVERVIEW ? <ContactOverview /> : <ContactContent />;
      break;


    default:
      console.error("INVALID ENGAGEMENT SELECTED -- ", selectedEngagement); // TODO: ERROR HANDLE
      break;
  }
}




/* ========================================================================= */
/* =============================== Schedule ================================ */
/* ========================================================================= */

/* =========================== Schedule Overview =========================== */
function ScheduleOverview() {

  return (
    <OverviewOptions />
  );
}


/* =========================== Schedule Content =========================== */

function ScheduleContent() {

  const { selectedOption } = useCoaching();

  return (
    <>
      {renderScheduleContent( selectedOption )}
    </>
  );
}

function renderScheduleContent( selectedOption: string ) {

  switch( selectedOption ) {
    case "bookNow": {
      return <BookNowOption />
    }

    case "myBookings": {
      return <MyBookingsOption />
    }

    case "preferences": {
      return <PreferencesOption />
    }

    default: {
      console.warn( `Unknown Option: ${selectedOption}` );
      return <FeatureComingSoon />
    }
  }

}

function BookNowOption() {

  return (
    <>
      <BookNowContentHeader />
      <BookNowContentBody />
    </>
  );
}

function BookNowContentHeader() {

  return (
    <ContentHeader />
  );
}

// TODO: This and My Bookings be UGLY .. Find cleaner way to do this all?
function BookNowContentBody() {

  const { selectedSubject, selectedTopic, selectedService } = useCoaching();

  const [ selectedAvailabilityObject, setSelectedAvailabilityObject ] = useState<any>(); // TODO: TYPE

  const [ appointmentModalOpen, setAppointmentModalOpen ] = useState( false );

  const toggleAppointmentModal = ( availabilityObject: any ) => { // TODO: TYPE
    setAppointmentModalOpen( !appointmentModalOpen );

    setSelectedAvailabilityObject( availabilityObject );

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "coaching_book-now_availability_card"
      },
      additionalDetails: {
        selectedSubject: selectedSubject,
        selectedTopic: selectedTopic,
        selectedService: selectedService,

        selectedAvailabilityObject: availabilityObject,
      }
    });

    document.body.classList.toggle( "no-scroll" );
  }

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="coaching_book-now_content_container">
      {
        isAuthorized ?
          <>
            <BookNowConfig />
            {/* TODO: toggleAppointmentModal IS BEING PROP DRILLED PRETTY DEEP, like 3 or more Components */}
            <BookNowAvailability toggleAppointmentModal={toggleAppointmentModal} />
            <BookNowLimits selectedTopic={selectedTopic} />

            {appointmentModalOpen ?
                <CoachingAppointmentModalContextProvider availabilityObject={selectedAvailabilityObject}>
                  <AppointmentModal closeModalHandler={toggleAppointmentModal} />
                </CoachingAppointmentModalContextProvider>
              :
                <></>
            }
          </>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }

    </div>
  );
}

enum DropDownSelectorType {
  SUBJECT = "subject",
  PROGRAM = "program",
  SESSION = "session",

  SERVICE = "service",

  SERVICE_HIGHLIGHT = "serviceHighlight",
}
function BookNowConfig() {
  const { selectedSubject, selectedTopic, selectedService } = useCoaching();
  const { selectSubject, selectTopic, selectService } = useCoachingUpdate();

  const { selectedAppointmentType } = useCoachingSchedule();
  const { selectAppointmentType } = useCoachingScheduleUpdate();

  return (
    <div className="coaching_book-now_config">
      <DropDownSelector selectorType={DropDownSelectorType.SUBJECT} selectedOption={selectedSubject} selectorFunction={selectSubject} />
      <DropDownSelector selectorType={DropDownSelectorType.PROGRAM} selectedOption={selectedTopic} selectorFunction={selectTopic} />

      <DropDownSelector selectorType={DropDownSelectorType.SERVICE} selectedOption={selectedService} selectorFunction={selectService} />

      {/* TODO: Need to decide if want keep this ability to filter... If so, consider proper integration
      <DropDownSelector selectorType={DropDownSelectorType.SESSION} selectedOption={selectedAppointmentType} selectorFunction={selectAppointmentType} />
      */}

      {/* TODO: If want have HeadsUpNotice for each Service Type (sort of a "hey, this is what it's all about"), then consider making this a Component and pass in Service Type, and then SWITCH on that, populating correct descriptionText and calloutText */}
      { selectedService === "consult" ?
          <HeadsUpNotice descriptionText="Consults are 60 minute, discussion-focused sessions to learn more about each other and determine fit." 
                         calloutText="Every user gets one free consult." />
        :
          <></>
      }
    </div>
  );
}

// TODO: STANDARDIZE - Some places I start Interfaces off with "I", others, I don't... (like here and many other "Component Props" Interfaces...) -- PICK ONE AND STICK WITH IT. Think makes sense to have I in front so know it's an Interface
interface HeadsUpNoticeProps {
  descriptionText: string;
  calloutText: string;
}
function HeadsUpNotice( { descriptionText, calloutText }: HeadsUpNoticeProps ) {
  return (
    <div className="heads-up_container">
      <div className="heads-up_description">
        {descriptionText}
      </div>
      <div className="heads-up_callout">
        {calloutText}
      </div>
    </div>
  );
}

interface BookNowAvailabilityProps {
  toggleAppointmentModal: any, // TODO: TYPE
}
function BookNowAvailability({ toggleAppointmentModal }: BookNowAvailabilityProps ) {

  //const [ availabilityData, setAvailabilityData ] = useState<any>(); // TODO: TYPE
  //const [ availabilityDataByMonth, setAvailabilityDataByMonth ] = useState<any>(); // TODO: TYPE
  const [ isLoading, setIsLoading ] = useState<boolean>( true );

  const { availabilityDataByMonth } = useCoachingSchedule();
  const { setAvailabilityDataByMonth } = useCoachingScheduleUpdate();
  
  useEffect( () => {
    const abortController = new AbortController();

    const retrieveAvailability = async () => {
      const organizedAvailabilityData = await retrieveCoachingAvailability({
        organizeBy: "month", 
        abortSignal: abortController.signal
      });

      setAvailabilityDataByMonth( organizedAvailabilityData );
      setIsLoading( false );
    }

    retrieveAvailability();

    return () => {
      abortController.abort();
    }
  }, []);


  return (
    <div className="coaching_book-now_availability alto-bg">
      { availabilityDataByMonth ?
          <>
            {availabilityDataByMonth.map( (availability: any, monthIndex: number) => { // TODO: TYPE
              const monthName = TimeService.getMonthNameFromNumber( monthIndex + 1 );
              return <AvailabilityMonthSection monthName={monthName} monthAvailability={availability} modalToggleFunction={toggleAppointmentModal} key={monthIndex} />;
            })}
          </>
        :
          isLoading ?
            <div className="loading">loading...</div> /*TODO: Proper loading Component (throughout App)*/
          :
            <div className="no-results">No Availability Found - Please try later</div>
      }
    </div>
  );
}

interface BookNowLimitsProps {
  selectedTopic: ProgramSelector,
}
function BookNowLimits({ selectedTopic }: BookNowLimitsProps ) {

  const { selectedOffer } = useCoaching();

  if( !selectedOffer ) {
    return (
      <div className="coaching_book-now_limits">
        <p>(no limits for this service)</p>
      </div>
    );
  }

  //const [ coachingPrice, setCoachingPrice ] = useState<number>();

  const coachingPrice = selectedOffer.price;
  const coachingSeatsLeft = selectedOffer.seatsLeft;
  let cohortDeadlineISO8601DateTime = selectedOffer.cohortDeadline;

  let cohortDeadline;
  if( cohortDeadlineISO8601DateTime ) {
    const { dayNumber, monthNumber, yearNumber } = TimeService.extractDateTimeISO8601Components( cohortDeadlineISO8601DateTime );
    cohortDeadline = `${monthNumber}/${dayNumber}/${yearNumber}`;
  }

  return (
    <div className="coaching_book-now_limits">
      <p>Price for <span className="highlighted-bold-text">{selectedOffer.name}</span> Service: 
        {coachingPrice ? 
          (<>
            <span className="highlighted-bold-text">{` $${coachingPrice}`}</span> / session
          </>) 
        : 
          " Varies (contact me to learn more)"}</p>
      { coachingSeatsLeft ? 
          // TODO: Like in the DropDownSelector, see if better way than to fromCamelCaseToCapitalizedSpaced() on this...
          // ... May not matter in terms of performance (may not be big hit), but it's ugly and error prone that I need to do this in multiple places. Caller/user of this State may not know it's camelCase (so consider at least renaming, or something)
          <p>Currently accepting {coachingSeatsLeft > 0 ? "only" : ""} <span className="highlighted-bold-text">{coachingSeatsLeft}</span> more student{coachingSeatsLeft > 1 || coachingSeatsLeft === 0 ? "s" : ""} for <span className="highlighted-bold-text">{fromCamelCaseToCapitalizedSpaced(selectedTopic)}</span></p>
        :
          <p>There are <span className="highlighted-bold-text">limited seats available</span> for this Program.</p>
      }
      { cohortDeadline ? 
          <p>I'm accepting new students through <span className="highlighted-bold-text">{cohortDeadline}</span></p>
        :
          <p>This <span className="highlighted-bold-text">Program has a deadline</span> for accepting new clients.</p>
      }
    </div>
  );
}

interface AvailabilityMonthSectionProps {
  monthName: string,
  monthAvailability: any[], // TODO: TYPE
  modalToggleFunction: any, // TODO: UGLY... PROP DRILLING - CLEAN UP - FIND BETTER WAY
}
function AvailabilityMonthSection( {monthName, monthAvailability, modalToggleFunction}: AvailabilityMonthSectionProps ) {

  if( monthAvailability.length <= 0 ) return <></>;

  return (
    <div className="coaching_book-now_availability_month-section">
      <h2 className="coaching_book-now_availability_month-name">{monthName}</h2>

      {monthAvailability.map( (availabilityObject: any, index: number) => { // TODO: TYPE
        return <AvailabilityCard availabilityObject={availabilityObject} modalToggleFunction={modalToggleFunction} key={index} />
      })}
    </div>
  );
}
interface AvailabilityCardProps {
  availabilityObject: any; // TODO: TYPE

  modalToggleFunction: any, // TODO: Type... It's a Function w/ Args though
}
function AvailabilityCard( {availabilityObject, modalToggleFunction}: AvailabilityCardProps ) {
  const startDateTimeISO8601 = availabilityObject.startDateTimeISO8601;
  const endDateTimeISO8601 = availabilityObject.endDateTimeISO8601;
  const timezone = availabilityObject.timezone;

  const isRecurring = availabilityObject.isRecurring;

  const { dayNumber, time24, timezoneOffset } = TimeService.extractDateTimeISO8601Components( startDateTimeISO8601 );
  const dayOfWeek = TimeService.getDayOfWeekFromDate( startDateTimeISO8601 ); // TODO: Verify returns dayOfWeek from an ISO8601 Date TIME string

  const dayOfMonthWithSuffix = TimeService.getDayOfMonthOrdinalWithSuffix( dayNumber );

  const time12 = convertTo12HourFormat( time24 );
  
  const timezoneAbbreviation = TimeService.getTimezoneAbbreviation( startDateTimeISO8601, timezone );

  return (
    <div onClick={() => modalToggleFunction( availabilityObject )} className="coaching_book-now_availability_card white-bg">
      {/*<div className={`coaching_book-now_availability_card_type ${isRecurring ? "recurring-event" : "adhoc-event"}`}>{isRecurring ? "Recurring" : "Adhoc"}</div>*/}
      {dayOfMonthWithSuffix} - {dayOfWeek} - {time12} {timezoneAbbreviation}
    </div>
  );
}
//....................... // TODO: DO THIS ON THE SERVER !!!!!!!!!!
function organizeAvailabilityObjectsByMonth( availabilityObjects: any[] ) { // TODO TYPE
  if( !availabilityObjects || availabilityObjects.length <= 0 ) return;

  const organized: any = Array(12).fill(null).map( () => [] );

  availabilityObjects.map( (availability: any) => { // TODO: TYPE
    const dateTime = availability.startDateTimeISO8601;
    const { monthNumber } = TimeService.extractDateTimeISO8601Components( dateTime );

    organized[ monthNumber - 1 ].push( availability );
  });

  return organized;
}



interface AppointmentModalProps {
  closeModalHandler: any, // TODO TYPE PROPERLY
}
function AppointmentModal( { closeModalHandler }: AppointmentModalProps ) {


  // For Analytics only...
  const { selectedSubject, selectedTopic, selectedService } = useCoaching();
  const { googleAvailabilityEventIds } = useCoachingAppointmentModalContext();

  const { email, requestDetails, formattedTime, formattedDate, eventSupportsRecurring, makeEventRecurring } = useCoachingAppointmentModalContext();
  const { updateEmail, updateRequestDetails, toggleRecurringEvent, submitAppointment } = useCoachingAppointmentModalContextUpdate();

  const [ isLoading, setIsLoading ] = useState<boolean>( false );
  const [ isSubmitted, setIsSubmitted ] = useState<boolean>( false );


  const handleSubmitAppointment = async ( event: SyntheticEvent ) => {
    event.preventDefault();

    setIsLoading( true );

    await submitAppointment();

    setIsLoading( false );
    setIsSubmitted( true );

    reportInteraction({
      interactionType: "submit", // InteractionType.SUBMIT, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "coaching_book-now_appointment-modal_button"
      },
      additionalDetails: {
        selectedSubject: selectedSubject,
        selectedTopic: selectedTopic,
        selectedService: selectedService,

        availabilityDetails: {
          email,
          requestDetails,

          formattedDate,
          formattedTime,

          makeEventRecurring,
          googleAvailabilityEventIds,
        }
      }
    });
  }

  const handleRecurringSelection = () => {
    toggleRecurringEvent()

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "coaching_book-now_appointment-modal_user-input_recurring"
      },
      additionalDetails: {
        selectedSubject: selectedSubject,
        selectedTopic: selectedTopic,
        selectedService: selectedService,

        availabilityDetails: {
          formattedDate: formattedDate,
          formattedTime: formattedTime,

          makeEventRecurring: !makeEventRecurring, // Since React hasn't re-rendered yet, so old value still
        }
      }
    });
  }


  return (
    <>
        {
          isSubmitted ?
            <div className="coaching_book-now_appointment-modal_confirmation white-bg">
              <h2 className="coaching_book-now_appointment-modal_header">Appointment Requested!</h2>

              <div className="coaching_book-now_appointment-modal_overview">
                <div className="coaching_book-now_appointment-modal_overview_date">
                  <h3>Date:</h3>
                  <span>{formattedDate}</span>
                </div>

                <div className="coaching_book-now_appointment-modal_overview_time">
                  <h3>Time:</h3>
                  <span>{formattedTime}</span>
                </div>

                <div className="coaching_book-now_appointment-modal_overview_details">
                  <p>You can manage your appointment on the "My Bookings" tab</p>
                </div>
              </div>

              <button className="coaching_book-now_appointment-modal_button brand-bg white-text" onClick={closeModalHandler}>Close</button>
            </div>
          :
            /* NOTE: Animating Height change is hard, here's one way that seems most promising from research: https://levelup.gitconnected.com/reactjs-approach-dynamic-animation-with-height-auto-or-unknown-height-a55562e01f59 */
            <div className="coaching_book-now_appointment-modal_request">
              <form className="coaching_book-now_appointment-modal_form white-bg" onSubmit={handleSubmitAppointment}>
                <h2 className="coaching_book-now_appointment-modal_header">Appointment Details</h2>

                <div className="coaching_book-now_appointment-modal_overview">
                  <div className="coaching_book-now_appointment-modal_overview_date">
                    <h3>Date:</h3>
                    <span>{formattedDate}</span>
                  </div>

                  <div className="coaching_book-now_appointment-modal_overview_time">
                    <h3>Time:</h3>
                    <span>{formattedTime}</span>
                  </div>
                </div>

                <div className="coaching_book-now_appointment-modal_user-input">
                  <div className="coaching_book-now_appointment-modal_user-input_email">
                    <h3>Email:</h3>
                    <input value={email} type="text" placeholder="Enter your email..." onChange={(e) => updateEmail(e.target.value)} required />
                  </div>

                  <div className="coaching_book-now_appointment-modal_user-input_request">
                    <h3>Add details about your request</h3>
                    <textarea value={requestDetails} placeholder="Context, goals for the session, etc." onChange={(e) => updateRequestDetails(e.target.value)} required />
                  </div>

                  <div className="coaching_book-now_appointment-modal_user-input_recurring">
                      { eventSupportsRecurring ?
                        <h4>Make this a recurring appointment?</h4>
                        :
                        <h4 style={{fontWeight: "initial"}}>This appointment can't be made recurring.</h4>
                      }
                    <input checked={makeEventRecurring} disabled={!eventSupportsRecurring} type="checkbox" onChange={handleRecurringSelection} />
                  </div>

                  {
                    makeEventRecurring ?
                      <RecurringConfig />
                    :
                      <></>
                  }
                </div>

                {
                  isLoading ?
                    <span>loading...</span> /*TODO: Proper loading*/
                  :
                    <button className="coaching_book-now_appointment-modal_button brand-bg white-text" type="submit">Schedule Now</button>
                }
              </form>
            </div>
        }

      <div onClick={closeModalHandler} className="screen-overlay"></div>
    </>
  );
}



function RecurringConfig() {

  const { startDateTimeISO8601, timezone,
          recurringStartDate, recurringEndDate, recurringDaysChecked, recurringDayTimes } = useCoachingAppointmentModalContext();
  const { updateRecurringStartDate, updateRecurringEndDate, updateRecurringDaysChecked, updateRecurringDayTimes } = useCoachingAppointmentModalContextUpdate();

  const [ availabilityDataByDayOfWeek, setAvailabilityDataByDayOfWeek ] = useState<any>();
  const [ isLoading, setIsLoading ] = useState<boolean>( true );

  const [ selectedDayOfWeek, setSelectedDayOfWeek ] = useState<string>();

  const dateTimeISO8601ToAvailabilityEventIdRef = useRef<{[key: string]: string}>({});


  useEffect( () => {
    const abortController = new AbortController();

    // TODO: PERFORMANCE This called (i.e. Network Call) EVERY TIME Toggle Reccuring Appointment Checkbox
    // --- Could this be done in CoachingAppointmentModalContext useEffect? Or keep track if already loaded via Context State (e.g. "loadedRecurringAvailability" or something that would indicate such??)
    const retrieveAvailability = async () => {
      const organizedAvailabilityData = await retrieveCoachingAvailability({
        organizeBy: "dayOfWeek", 
        recurringOnly: true,
        abortSignal: abortController.signal,
      });

      setAvailabilityDataByDayOfWeek( organizedAvailabilityData );

      const allUniqueAvailabilityObjects = Object.values(organizedAvailabilityData).flat();
        console.log("UNIQUE AVAILABILITY", allUniqueAvailabilityObjects);
      allUniqueAvailabilityObjects.forEach( (availabilityObject: any) => {
        dateTimeISO8601ToAvailabilityEventIdRef.current[ availabilityObject.startDateTimeISO8601 ] = availabilityObject.googleAvailabilityEventId;
      });
      console.log("MAPPING OF AVAILABILITY", dateTimeISO8601ToAvailabilityEventIdRef.current);

      // TODO: Error handle
      const dayOfWeek = TimeService.getDayOfWeekFromDate(startDateTimeISO8601)?.toLowerCase();
      setSelectedDayOfWeek( dayOfWeek );

      console.log("RETRIEVE AVAILABILITY START DATE TIME", startDateTimeISO8601);
      updateRecurringDayTimes( dayOfWeek, startDateTimeISO8601, dateTimeISO8601ToAvailabilityEventIdRef.current );
      setIsLoading( false );
    }

    retrieveAvailability();

    return () => {
      abortController.abort();
    }
  }, []);

  const minDatePicker = startDateTimeISO8601.split("T")[0]; // TODO: ERROR HANDLE (if [0] not exist...)
  // TODO: PROBLEM: I notice when something like 6 months, it just spams a TON of AVAILABILITY Event Creations, I end up Rate Limited. It's cuz when recreate, it's trying to recreate ONE AT A TIME for EVERY Event...
  // ... DEFAULTING TO 3 MONTHS FOR NOW... Need fix a lot in terms of ability to recognize when at end of Recurring Event Series so not need hard-code (which may end up doing so past point of where I actually have Availability)
  const maxDatePicker = TimeService.addUnitsToDateTimeISO8601( 2, TimeUnits.MONTHS, startDateTimeISO8601, timezone ).split("T")[0] // TODO: ERROR HANDLE (if [0] not exist...);

  return (
    <div className="coaching_book-now_appointment_modal_recurring-config">

      <div className="recurring-config_date-picker_container">
        {/* TODO: Currently not used as DTSTART is NOT supported in Google Calendar, meant to use the start dateTime field as the start of Recurrence
        <div className="recurring-config_date-picker">
          {// Need to be in YYYY-MM-DD format }
          <label htmlFor="start-date-picker">Start Date: </label>
          <input id="start-date-picker" type="date" value={recurringStartDate} onChange={(e) => updateRecurringStartDate(e.target.value)} min={minDatePicker} max={maxDatePicker} />
        </div>
        */}

        <div className="recurring-config_date-picker">
          {/* TODO: Consider making this pre-populated with "Recommended Length" -- I can keep this info in some config? (indicator (i) icon or something to show it can change later...?) */}
          {/* Need to be in YYYY-MM-DD format */}
          <label htmlFor="end-date-picker">End Date: </label>
          <input id="end-date-picker" type="date" value={recurringEndDate} onChange={(e) => updateRecurringEndDate(e.target.value)} min={minDatePicker} max={maxDatePicker} />
        </div>
      </div>

      <hr/>


      <div className="recurring-config_day-time-picker_container">
        <h3>Days of Week to Include (can vary times)</h3>

        {
          isLoading ?
            <div className="loading">loading...</div> /*TODO: Proper loading*/
          :
            Object.entries(recurringDaysChecked).map( ([day, isChecked]) => {
              // TODO: PERFORMANCE - Seems this is re-rendered every time something like email or request details change... (if console.log(), it shows it to be so)
              const properCasedDay = day?.charAt(0).toUpperCase() + day.slice(1); // TODO: Move to helper (?) More efficient way?

              const dayOfWeekAvailability = availabilityDataByDayOfWeek[day];

              //if( !dayOfWeekAvailability ) return <></>; // TODO: (DECIDE) Can use this instead if ONLY want show Days that have Availability
              const hasAvailability: boolean = dayOfWeekAvailability ? true : false;
              let firstOptionMessage = hasAvailability ? "--Please select a time--" : "No recurring times found";

              // TODO: Find more concise, clean way to do this (make a function?)
              //const selectedDayTime = isChecked && !recurringDayTimes[day] && dayOfWeekAvailability.length > 0 ? (updateRecurringDayTimes(day, dayOfWeekAvailability[0].startDateTimeISO8601), dayOfWeekAvailability[0].startDateTimeISO8601) : recurringDayTimes[day];
              let selectedDayTime = recurringDayTimes[day];
              if( isChecked && !recurringDayTimes[day] && dayOfWeekAvailability.length > 0 ) {
                const startDateTime = dayOfWeekAvailability[0].startDateTimeISO8601;
                console.log("IS CHECKED ... START DATE TIME & MAPPING", startDateTime, dateTimeISO8601ToAvailabilityEventIdRef.current);
                updateRecurringDayTimes(day, startDateTime, dateTimeISO8601ToAvailabilityEventIdRef.current);
                selectedDayTime = startDateTime;
              }

              const dayInputDisabled = !hasAvailability || day == selectedDayOfWeek;
              
              return (
                <div className="recurring-config_day-time-picker">
                  <input type="checkbox" disabled={dayInputDisabled} checked={isChecked as boolean} onChange={() => updateRecurringDaysChecked(day, dateTimeISO8601ToAvailabilityEventIdRef.current)} />
                  <label htmlFor={day}>{properCasedDay}</label>
                  {/*<select id={day} value={recurringDayTimes[day]} name={day} onChange={(e) => updateRecurringDayTimes(day, e.target.value)}>*/}
                  <select id={day} value={selectedDayTime} disabled={dayInputDisabled} name={day} onChange={(e) => updateRecurringDayTimes(day, e.target.value, dateTimeISO8601ToAvailabilityEventIdRef.current)}>
                    <option value="">{firstOptionMessage}</option>

                    {dayOfWeekAvailability?.map( (availability: any) => { // TODO: TYPE
                      // TODO: PERFORMANCE concerns with doing this for every option there is? -- Some way do on Server when organize by Day?
                      const startDateTime = availability.startDateTimeISO8601;
                      const { dayNumber, time24, timezoneOffset } = TimeService.extractDateTimeISO8601Components( startDateTime );
                      //const dayOfMonthWithSuffix = TimeService.getDayOfMonthOrdinalWithSuffix( dayNumber );
                      const time12 = convertTo12HourFormat( time24 );
                      const timezoneAbbreviation = TimeService.getTimezoneAbbreviation( startDateTime, availability.timezone );

                      const time12String = `${time12} ${timezoneAbbreviation}`;

                      return (
                        <option value={startDateTime}>{time12String}</option>
                      );
                    })}
                  </select>
                </div>
              );
            })
        }


      </div>

    </div>
  );
}




function MyBookingsOption() {

  return (
    <>
      <MyBookingsContentHeader />
      <MyBookingsContentBody />
    </>
  );
}

function MyBookingsContentHeader() {

  return (
    <ContentHeader />
  );
}

enum AppointmentStage {
  REQUESTED = "Requested",
  CONFIRMED = "Confirmed",

  PAST = "Past"
}
function MyBookingsContentBody() {

  const [ confirmedAppointments, setConfirmedAppointments ] = useState<any>([]); // TODO: TYPE
  const [ requestedAppointments, setRequestedAppointments ] = useState<any>([]); // TODO: TYPE
  const [ pastAppointments, setPastAppointments ] = useState<any>([]); // TODO: TYPE

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)

  useEffect( () => {

    // TODO: CACHE ON CLIENT -- AND ONLY REDO IF THESE CHANGE (but not in Dependency Array as will be called each re-render, i.e. when move away from this page and back again)
    const retrieveEvents = async () => {
      const scheduleEventsEndpoint = "/api/v1/coaching/schedule/events";

      const result = await fetch( scheduleEventsEndpoint, {
        method: "GET", // Explicitly differentiating from POST used in Book Now / Schedule API call
      });

      if( result == null || !result.ok ) { // TODO: Other/better ERROR HANDLING (?)
        console.error( "ERROR Retrieving Appointments", result.status)
      }

      const responseBody = await result.json();

      const requestedAppointments = responseBody.requestedAppointments;
      const confirmedAppointments = responseBody.confirmedAppointments;
      const pastAppointments = responseBody.pastAppointments;
  
      setRequestedAppointments( requestedAppointments );
      setConfirmedAppointments( confirmedAppointments );
      setPastAppointments( pastAppointments );
    };

    if( isAuthorized ) retrieveEvents();
  }, [user]);



  return (
    <div className="coaching_my-bookings_content_container">
      {
        isAuthorized ?
          <>
            <AppointmentSection appointments={requestedAppointments} appointmentStage={AppointmentStage.REQUESTED} />
            <AppointmentSection appointments={confirmedAppointments} appointmentStage={AppointmentStage.CONFIRMED} />
            <AppointmentSection appointments={pastAppointments} appointmentStage={AppointmentStage.PAST} />
          </>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }
    </div>
  );
}

interface AppointmentSectionProps {
  appointments: any[]; // TODO: TYPE

  appointmentStage: AppointmentStage,
}
function AppointmentSection({ appointments, appointmentStage }: AppointmentSectionProps ) {

  return (
    <div className="coaching_my-bookings_section_container">

      <h3 className="coaching_my-bookings_section_header">{appointmentStage} Appointments</h3>

      {appointments?.length > 0
        ? 
          appointments.map( (appointment: any, index: number) => { // TODO: TYPE

            const startDateTimeString: string = appointment.startDateTime;
            const timezone: string = appointment.timezone;

            // TODO: Find better way not repeat self with CoachingAppointmentModalContextProvider since doing so in 3 places below right now... (for each return...) -- But appointment only available in this context, so maybe somehow have it wrapping another {} expression code block with the actual switch?, or render a Switch Component (helper / inline-to-this-function / nested function) ??
            switch( appointmentStage ) {
              case AppointmentStage.REQUESTED: {
                //return <BookedAppointmentCard eventId={appointment.googleEventId} meetingLink={appointment.meetingLink} startDateTimeString={startDateTimeString} timezone={timezone} cardType="Request" key={index} />
                return <BookedAppointmentCard appointment={appointment} cardType="Request" key={index} />
                /*
                return (
                  <CoachingAppointmentModalContextProvider availabilityObject={appointment}>
                    <BookedAppointmentCard appointment={appointment} cardType="Request" key={index} />
                  </CoachingAppointmentModalContextProvider>
                );
                */
              }

              case AppointmentStage.CONFIRMED: {
                //return <BookedAppointmentCard eventId={appointment.googleEventId} meetingLink={appointment.meetingLink} startDateTimeString={startDateTimeString} timezone={timezone} cardType="Appointment" key={index} />
                return <BookedAppointmentCard appointment={appointment} cardType="Appointment" key={index} />
                /*
                return (
                  <CoachingAppointmentModalContextProvider availabilityObject={appointment}>
                    <BookedAppointmentCard appointment={appointment} cardType="Appointment" key={index} />
                  </CoachingAppointmentModalContextProvider>
                );
                */
              }

              case AppointmentStage.PAST: {
                return <PastAppointmentCard appointment={appointment} timezone={timezone} key={index} />
                /*
                return (
                  <CoachingAppointmentModalContextProvider availabilityObject={appointment}>
                    <PastAppointmentCard startDateTimeString={startDateTimeString} timezone={timezone} key={index} />
                  </CoachingAppointmentModalContextProvider>
                );
                */
              }

              default: {
                console.warn( `WARNING: Unknown Appointment Type - ${appointmentStage}` );
                break;
              }
            }
          })
        : 
          <span>NO {appointmentStage.toUpperCase()} APPOINTMENTS ...</span> /* TODO: PROPER CARD(?) / HTML */
      }
    </div>
  );
}

interface BookedAppointmentCardProps {
  /*eventId: string,

  meetingLink: string,

  startDateTimeString: string,
  timezone: string,*/
  appointment: any, // TODO: TYPE

  cardType: string,
}
//function BookedAppointmentCard({ eventId, meetingLink, startDateTimeString, timezone, cardType }: BookedAppointmentCardProps ) {
  // TODO: See if can do better than the Prop Drilling of "appointment" from parent of this Component to several Descendents
function BookedAppointmentCard({ appointment, cardType }: BookedAppointmentCardProps ) {

  const { selectEventId } = useCoachingScheduleUpdate();

  // TODO: Temporary hardcoded for testing
  const confirmationMethod = "email";
  const appointmentType = appointment.hasOwnProperty("recurringConfig") ? fromCamelCaseToCapitalizedSpaced(AppointmentType.RECURRING) : fromCamelCaseToCapitalizedSpaced(AppointmentType.ADHOC);
  const serviceType = appointment.hasOwnProperty("service") ? fromCamelCaseToCapitalizedSpaced(appointment["service"]) : "Tutoring";

  /*
  let eventId;
  switch( appointmentType ) {
    case AppointmentType.ADHOC: {
      eventId = appointment.googleEventIds[0];
      break;
    }

    case AppointmentType.RECURRING: {
      //eventId = appointment.googleEventId;
      break;
    }
  }
    */

  const [ modalOpen, setModalOpen ] = useState<boolean>( false );
  const [ modalType, setModalType ] = useState<BookingModalType>();

  const toggleModal = () => {
    setModalOpen( !modalOpen ); // TODO: Can this and modalType be reduced to one...? Tried using setModalType instead and rely on undefined for Swtich in <BookingModal>, but it doesn't seem to properly open Modal (removes Scrollbar though, but Modal Overlay doesn't show at all) 

    // TODO: Currently causes app to shift over due to Scrollbar disappearing
    document.body.classList.toggle( "no-scroll" ); // TODO: Better way...?
  }

  const handleSelectEvent = ( modalType: BookingModalType ) => {
    selectEventId( appointment.googleEventIds ); // TODO: BAD - Need select specific Event ID...

    setModalType( modalType );

    toggleModal();

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to Shared Repo
      interactionDetails: {
        elementId: `coaching_my-bookings_section_card_details_${modalType}_button`,
      },
      additionalDetails: {
        appointmentType: appointment.appointmentType,
        serviceType: appointment.service,
        formattedDateTimeStartString,
        appointmentStatus: appointment.status,
      },
    });
  }


  const formatDateTimeString = () => {

    const startDateTimeString: string = appointment.startDateTime;
    
    switch( appointmentType ) {
      case AppointmentType.RECURRING: {
        return getDayTimesFormattedStringFromRecurringConfig( appointment.recurringConfig );
      }

      case AppointmentType.ADHOC: {
        return TimeService.convertDateTimeStringToFormattedString( startDateTimeString );
      }

      default: {
        return "(appointment type not supported)";
      }
    }
  };


  const formattedDateTimeStartString = formatDateTimeString();

  const appointmentRequested = appointment.status === AppointmentStage.REQUESTED;


  const handleJoinMeeting = () => {
    window.open(appointment.meetingLink, "_blank");

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to Shared Repo
      interactionDetails: {
        elementId: "coaching_my-bookings_section_card_join-meeting-button",
      },
      additionalDetails: {
        appointmentType: appointment.appointmentType,
        serviceType: appointment.service,
        formattedDateTimeStartString,
        appointmentStatus: appointment.status,
      },
    });
  }

  return (
    <>
      <div className="coaching_my-bookings_section_card alto-bg">
        <button className="coaching_my-bookings_section_card_details_pay-button burnt-orange-bg white-text" onClick={() => handleSelectEvent(BookingModalType.PAY)}>Pay</button>

        <h4 className="coaching_my-bookings_section_card_header">
          Check your <span className="highlight-color-text">{confirmationMethod}</span> for confirmation details.
        </h4>

        <h3 className="coaching_my-bookings_section_card_details_header">Details</h3>
        <div className="coaching_my-bookings_section_card_details_body">
          <div><span style={{}}>Type:</span> <span className="highlight-color-text">{appointmentType}</span></div>
          <div><span style={{}}>Service:</span> <span className="highlight-color-text">{serviceType}</span></div>
          <div><span style={{}}>Date/Time:</span> <span className="highlight-color-text">{formattedDateTimeStartString}</span></div>
        </div>

        <button className="coaching_my-bookings_section_card_details_manage-button persian-red-bg white-text" onClick={() => handleSelectEvent(BookingModalType.MANAGE)}>Manage</button>

        <button className={`coaching_my-bookings_section_card_details_artifacts-button japanese-laurel-bg white-text ${appointmentRequested ? "button-disabled" : ""}`} onClick={() => handleSelectEvent(BookingModalType.ARTIFACTS)}>Artifacts</button>

        <button className={`coaching_my-bookings_section_card_join-meeting-button brand-bg white-text ${appointmentRequested ? "button-disabled" : ""}`} onClick={handleJoinMeeting}>
          Join
        </button>
      </div>


      { modalOpen ? 
          <BookingModal appointment={appointment} modalType={modalType} cardType={cardType} closeModalHandler={toggleModal} />
        : 
          <></> 
      }
    </>
  );
}

enum BookingModalType { // TODO: Move this (and FeatureAspect in Program.tsx) to Shared Repo (enums.ts - types)
  PAY = "pay",
  MANAGE = "manage",
  ARTIFACTS = "artifacts",
}
interface BookingModalProps {
  appointment: any, // TODO: TYPE

  modalType: BookingModalType | undefined,

  cardType: string, 

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
// TODO: Consider better name... ? BookingModal is pretty generic and may be better as "MyBookingsModal" or "AppointmentCardModal" or "AppointmentBookingModal" (AppointmentModal already (kinda) taken in Book Now tab)
function BookingModal( { appointment, modalType, cardType, closeModalHandler }: BookingModalProps ) {
  const renderModalType = useCallback( () => {

    switch( modalType ) {
      case BookingModalType.PAY: {
        return <PayModal appointment={appointment} cardType={cardType} closeModalHandler={closeModalHandler} />
        break;
      }

      case BookingModalType.MANAGE: {
        return <ManageAppointmentModal appointment={appointment} cardType={cardType} closeModalHandler={closeModalHandler} />
        break;
      }

      case BookingModalType.ARTIFACTS: {
        return <ArtifactsModal appointment={appointment} cardType={cardType} closeModalHandler={closeModalHandler} />
        break;
      }

      default: {
        return <></>; // TODO: Error Handle ??
        break;
      }
    }
  }, [modalType]);

  return (
    <>
      {
        renderModalType()
      }
    </>
  );
}


interface PayModalProps {
  appointment: any, // TODO: TYPE

  //formattedDateTimeStartString: string,

  cardType: string, // TODO: TYPE PROPERLY (ENUM?)

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
function PayModal( { appointment, cardType, closeModalHandler }: PayModalProps ) {

  return (
    <>
      <div onClick={closeModalHandler} className="screen-overlay"></div>
      <form className="coaching_my-bookings_pay_modal_form white-bg">
        <h2 className="coaching_my-bookings_pay_modal_header">Payment Methods</h2>

        <VenmoButton amountPay={appointment.price as number} note={`${appointment.subject}|${appointment.topic} Crash Course Session`} /> {/* TODO: ERROR HANDLE hard-code type*/}
        <PayPalButton />

        {/*
        { googleDriveHomeLink ? <button className="tamarillo-bg" onClick={() => window.open(googleDriveHomeLink, "_blank")}>Google Drive Home</button> : <p>No Google Drive Home Link</p> }
        { metaSessionInfoLink ? <button className="brand-bg" onClick={() => window.open(metaSessionInfoLink, "_blank")}>Meta-Session Info</button> : <p>No Meta-Session Info Link</p> }
        { sessionsFolderLink ? <button className="japanese-laurel-bg" onClick={() => window.open(sessionsFolderLink, "_blank")}>Session Notes</button> : <p>No Session Notes Link</p> }
        */}
      </form>
    </>
  );
}

interface ManageModalProps {
  appointment: any, // TODO: TYPE

  //formattedDateTimeStartString: string,

  cardType: string, // TODO: TYPE PROPERLY (ENUM?)

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
//function ManageAppointmentModal( { appointment, formattedDateTimeStartString, cardType, closeModalHandler }: ManageModalProps ) {
function ManageAppointmentModal( { appointment, cardType, closeModalHandler }: ManageModalProps ) {

  const { selectEventId, selectRecurringInstance } = useCoachingScheduleUpdate();

  return (
    <>
      { appointment.recurringConfig ? 
          <ManageRecurringAppointmentModal appointment={appointment} cardType={cardType} closeModalHandler={closeModalHandler} />
        :
          <ManageAdhocAppointmentModal appointment={appointment} cardType={cardType} closeModalHandler={closeModalHandler} />
      }
    </>
  );
}

function ManageRecurringAppointmentModal({ appointment, cardType, closeModalHandler }: ManageModalProps) {

  const { selectEventId, selectRecurringInstance } = useCoachingScheduleUpdate();

  const [ modalOpen, setModalOpen ] = useState<boolean>( false );
  const [ modalType, setModalType ] = useState<AppointmentModalType>();

  const [ selectedStartDateTimeString, setSelectedStartDateTimeString ] = useState<string | undefined>();

  const eventInstances = appointment.recurringConfig?.eventInstances;

  const toggleModal = ( eventId?: string, cancelled?: boolean ) => {
    setModalOpen( !modalOpen ); // TODO: Can this and modalType be reduced to one...? Tried using setModalType instead and rely on undefined for Swtich in <BookingModal>, but it doesn't seem to properly open Modal (removes Scrollbar though, but Modal Overlay doesn't show at all) 

    // TODO: Currently causes app to shift over due to Scrollbar disappearing
    document.body.classList.toggle( "no-scroll" ); // TODO: Better way...?

    if( eventId ) {
      selectEventId( eventId );

      cancelled && eventInstances ? delete eventInstances[eventId] : selectRecurringInstance( eventInstances[eventId] );
    }
    else {
      selectEventId( appointment.googleEventId );
      selectRecurringInstance();
      setSelectedStartDateTimeString(undefined);
    }
  }

  const handleSelectEvent = ( eventId: string, startDateTimeString: string, modalType: AppointmentModalType ) => {
    setModalType( modalType );

    setSelectedStartDateTimeString( startDateTimeString );

    toggleModal( eventId );
  }


  return (
    <>
      { !modalOpen ? 
          <>
            <div onClick={closeModalHandler} className="screen-overlay"></div>

            {/* TODO: Change Class Names to be more appropriate, or GENERALIZE THEM for reuse */}
            <div className="coaching_my-bookings_manage_modal_container white-bg">
              <h2 className="coaching_my-bookings_manage_modal_header">Recurring Appointment Instances</h2>

              {/* TODO: YOU ARE HERE
                  ... NEED separate the below into Components, one for ManageRecurring, one for ManageAdhoc ...
                  ... Currently shows "Recurring Appointment Instances: ..." EVEN FOR ADHOC APPOINTMENTSk
              */}
              <div className="coaching_my-bookings_manage_modal_appointments_container">
                { eventInstances != null && Object.keys(eventInstances).length > 0
                  ?
                    Object.keys(eventInstances).map( (eventId: string) => {
                      //const startDateTimeString = eventId.split( "_" )[1]; // TODO: ERROR HANDLE - UGLY (better way...?)
                      const eventInstance = eventInstances[eventId];
                      if( !eventInstance ) { console.error(`No Event Instance for Event ID: ${eventId}`); return <></> }
                      const startDateTimeString = eventInstance.dateTimeString;
                      // TODO: PERFORMANCE ?? Below convertion done repeatedly sounds like bad idea (AND DOING IN Actual Canel Modal... INEFFICIENT - How can do once or reuse ...?)
                      const formattedDateTimeStartString = TimeService.convertDateTimeStringToFormattedString( startDateTimeString );

                      return (
                        <div className="coaching_my-bookings_manage_modal_appointment_instance alto-bg">
                            <button className="coaching_my-bookings_manage_modal_appointment_instance_modify-button japanese-laurel-bg white-text" onClick={() => handleSelectEvent(eventId, startDateTimeString, AppointmentModalType.MODIFY)}>Modify</button>
                            <span className="highlight-color-text">{formattedDateTimeStartString}</span>
                            <button className="coaching_my-bookings_manage_modal_appointment_instance_cancel-button persian-red-bg white-text white-text" onClick={() => handleSelectEvent(eventId, startDateTimeString, AppointmentModalType.CANCEL)}>Cancel</button>
                        </div>
                      );
                    })
                  :
                      <span>NONE</span>
                }

                {/* TODO: Below won't work yet cuz CancelModal relies on recurringInstance to be defined, 
                    ... but WON'T when deleting ENTIRE series (not a single recurringInstance)
                <button className="coaching_my-bookings_manage_modal_appointment_cancel-button" onClick={() => handleSelectEvent(appointment.googleEventId, AppointmentInstanceModalType.CANCEL)}>Cancel All</button>
                */}
              </div>
            </div>
          </>
        :
          <>
            <div onClick={() => toggleModal()} className="screen-overlay"></div>
            <AppointmentModalRenderer modalType={modalType} startDateTimeString={selectedStartDateTimeString} cardType={cardType} closeModalHandler={toggleModal} />
          </>
      }
    </>
  );
}

function ManageAdhocAppointmentModal({ appointment, cardType, closeModalHandler }: ManageModalProps) {

  const { selectEventId } = useCoachingScheduleUpdate();

  const [ modalOpen, setModalOpen ] = useState<boolean>( false );
  const [ modalType, setModalType ] = useState<AppointmentModalType>();


  const toggleModal = ( cancelled?: boolean ) => {
    setModalOpen( !modalOpen ); // TODO: Can this and modalType be reduced to one...? Tried using setModalType instead and rely on undefined for Swtich in <BookingModal>, but it doesn't seem to properly open Modal (removes Scrollbar though, but Modal Overlay doesn't show at all) 

    // TODO: Currently causes app to shift over due to Scrollbar disappearing
    document.body.classList.toggle( "no-scroll" ); // TODO: Better way...?

    selectEventId( appointment.googleEventIds[0] );
  }

  const handleSelectEvent = ( modalType: AppointmentModalType ) => {
    setModalType( modalType );

    toggleModal();
  }


  const startDateTimeString: string = appointment.startDateTime;
  const formattedDateTimeStartString = TimeService.convertDateTimeStringToFormattedString( startDateTimeString );


  return (
    <>
      { !modalOpen ? 
          <>
            <div onClick={closeModalHandler} className="screen-overlay"></div>

            {/* TODO: Change Class Names to be more appropriate, or GENERALIZE THEM for reuse */}
            <div className="coaching_my-bookings_manage_modal_container white-bg">
              <h2 className="coaching_my-bookings_manage_modal_header">Manage Appointment</h2>

              {/* TODO: YOU ARE HERE
                  ... NEED separate the below into Components, one for ManageRecurring, one for ManageAdhoc ...
                  ... Currently shows "Recurring Appointment Instances: ..." EVEN FOR ADHOC APPOINTMENTSk
              */}
              <div className="coaching_my-bookings_manage_modal_appointments_container">
                <div className="coaching_my-bookings_manage_modal_appointment_instance alto-bg">
                    <button className="coaching_my-bookings_manage_modal_appointment_instance_modify-button japanese-laurel-bg white-text" onClick={() => handleSelectEvent(AppointmentModalType.MODIFY)}>Modify</button>
                    <span className="highlight-color-text">{formattedDateTimeStartString}</span>
                    <button className="coaching_my-bookings_manage_modal_appointment_instance_cancel-button persian-red-bg white-text" onClick={() => handleSelectEvent(AppointmentModalType.CANCEL)}>Cancel</button>
                </div>

                {/* TODO: Below won't work yet cuz CancelModal relies on recurringInstance to be defined, 
                    ... but WON'T when deleting ENTIRE series (not a single recurringInstance)
                <button className="coaching_my-bookings_manage_modal_appointment_cancel-button" onClick={() => handleSelectEvent(appointment.googleEventId, AppointmentInstanceModalType.CANCEL)}>Cancel All</button>
                */}
              </div>
            </div>
          </>
        :
          <>
            <div onClick={() => toggleModal()} className="screen-overlay"></div>
            <AppointmentModalRenderer modalType={modalType} startDateTimeString={startDateTimeString} cardType={cardType} closeModalHandler={toggleModal} />
          </>
      }
    </>
  );
}


enum AppointmentModalType { // TODO: Move this (and FeatureAspect in Program.tsx) to Shared Repo (enums.ts - types)
  MODIFY = "modify",
  CANCEL = "cancel",
}
interface AppointmentModalRendererProps {
  modalType: AppointmentModalType | undefined,

  startDateTimeString: string | undefined,

  cardType: string, // TODO: TYPE PROPERLY (ENUM?)

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
// TODO: Consider better name... ? BookingModal is pretty generic and may be better as "MyBookingsModal" or "AppointmentCardModal" or "AppointmentBookingModal" (AppointmentModal already (kinda) taken in Book Now tab)
function AppointmentModalRenderer( { modalType, startDateTimeString, cardType, closeModalHandler }: AppointmentModalRendererProps ) {

  const renderModalType = useCallback( () => {

    if( !startDateTimeString ) {
      console.error( "ERROR: No valid Start Date Time for Appointment Instance Modal" );
      return <></>;
    }

    switch( modalType ) {
      case AppointmentModalType.MODIFY: {

        return (
          <>
            <div onClick={() => closeModalHandler()} className="screen-overlay"></div>
            <ModifyAppointmentModal startDateTimeString={startDateTimeString} cardType={cardType} closeModalHandler={closeModalHandler} />
          </>
        );
        break;
      }

      case AppointmentModalType.CANCEL: {
        return (
          <>
            <div onClick={() => closeModalHandler()} className="screen-overlay"></div>
            <CancelAppointmentModal startDateTimeString={startDateTimeString} cancelType={cardType} closeModalHandler={closeModalHandler} />
          </>
        );
        break;
      }

      default: {
        return <></>; // TODO: Error Handle ??
        break;
      }
    }
  }, [modalType]);

  return (
    <>
      {
        renderModalType()
      }
    </>
  );
}

interface ModifyAppointmentModalProps {
  startDateTimeString: string,

  cardType: string, // TODO: TYPE PROPERLY (ENUM?)

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
function ModifyAppointmentModal( { startDateTimeString, cardType, closeModalHandler }: ModifyAppointmentModalProps ) {

  const navigate = useNavigate();

  const { selectedEventId: eventId } = useCoachingSchedule();
  //const { selectedRecurringInstance } = useCoachingSchedule();

  //const { timezone } = useCoachingAppointmentModalContext();

  //const startDateTimeString = eventId.split( "_" )[1]; // TODO: ERROR HANDLE - UGLY (better way...?) & not so efficient
  //const startDateTimeString = selectedRecurringInstance.dateTimeString;
  const dateTimeHTMLPickerStartDateTime = TimeService.convertDateTimeStringToDateTimeHTMLPicker( startDateTimeString );
  const formattedDateTimeStartString = TimeService.convertDateTimeStringToFormattedString( startDateTimeString ); // TODO: INEFFICIENTLY DONE AGAIN HERE AS DONE IN LISTING APPOINTMENT INSTANCES IN PARENT COMPONENTS...


  const [ modifyReason, setModifyReason ] = useState<string>("");

  const [ newStartDateTime, setNewStartDateTime ] = useState<string>(dateTimeHTMLPickerStartDateTime);
  const [ newEndDateTime, setNewEndDateTime ] = useState<string>("");

  const handleUpdateModifyReason = ( updatedCancelReason: string ) => {
    setModifyReason( updatedCancelReason );
  }


  // !!!!!!!!!!!!!!!!!!!!!!!!!!! TODO TODO TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  // ... EVENT ID REMAINS UNCHANGED IF CHANGE DATE / TIME OF EVENT !!!!!!!!!!!!!!!!!!
  // ... i.e. NOT RELIABLE TO PARSE IT TO GET Date Time to show in UI !!!!!!!!!!!!!!!

  const handleModify = async () => {

    if( eventId == null ) {
      // TODO: ERROR HANDLE
      console.error( "Event ID Not Found - Cannot Modify" );
      return;
    }

    const modifyEventEndpoint = `/api/v1/coaching/schedule/events?action=MODIFY`;

    // TODO: Can try get timezone from useCoachingAppointmentModalContext BUT gives error due to not really meant to be done here...
    const newStartDateTimeISO8601 = TimeService.convertDateTimeHTMLPickerToDateTimeString( newStartDateTime, "America/Denver" );
    // TODO: HARDCODED TIMEZONE... (and 1 hour appointment time assumption...)
    const newEndDateTimeISO8601 = TimeService.addUnitsToDateTimeISO8601( 1, TimeUnits.HOURS, newStartDateTime, "America/Denver" );

    const modifiedAppointmentData = { 
      //subject: selectedSubject, 
      //topic: selectedTopic,
      //requestDetails,
      
      //appointmentType: selectedAppointmentType,

      //user: user,

      startDateTime: newStartDateTimeISO8601,
      endDateTime: newEndDateTimeISO8601,
      //timezone: timezone,

      //attendeeEmails: email ? [ email ] : null,

      //recurringConfig: makeEventRecurring ? { // May be false since Context saves state, unchecking makeEventRecurring doesn't remove recurringDaysChecked or recurringDayTimes
        //recurringStartDate: recurringStartDate,
        //recurringEndDate: recurringEndDate,

        //dayTimes: dayTimesForSelections,
      //} : undefined,

      googleEventId: eventId,
      //googleAvailabilityEventId: googleAvailabilityEventId,
    };

    console.log("modifiedAppointmentData", modifiedAppointmentData);

    const result = await fetch( modifyEventEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( modifiedAppointmentData ),
    });

    if( result == null || !result.ok ) { // TODO: Other/better ERROR HANDLING (?)
      console.error( `ERROR Modifying ${cardType}`, result.status)
    }

    //const responseBody = await result.json();

    closeModalHandler(); // TODO: What if MODIFY is not successful, handle differently?

    // TODO: Update client-side eventInstances state and do navigate(".", {replace: true }) instead (client-side component refresh instead of full-on reload)
    // ... Adding few second delay to give server time to modify/cancel event
    setTimeout( () => navigate(0), 1000 ); // Refresh the page to reflect the changes
  }


  // TODO: Make this an inline function to this function (it's a bit verbose... / ugly)
  const currentDate = new Date();
  const startDate = new Date( dateTimeHTMLPickerStartDateTime );
  const timeDifference = startDate.getTime() - currentDate.getTime(); // Difference in milliseconds
  const daysDifference = Math.floor( timeDifference / (TimeService.ONE_DAY_MILLIS) );
  const numberDaysInPast = daysDifference > 7 ? -7 : -daysDifference;
  const minDateTimePickerISO8601 = TimeService.addUnitsToDateTimeISO8601( numberDaysInPast, TimeUnits.DAYS, dateTimeHTMLPickerStartDateTime );
  const minDateTimePicker = TimeService.convertDateTimeStringToDateTimeHTMLPicker( minDateTimePickerISO8601 );
  //const minDateTimePicker = newStartDateTime; // TODO: ERROR HANDLE (if [0] not exist...)

  const maxDateTimePickerISO8601 = TimeService.addUnitsToDateTimeISO8601( 7, TimeUnits.DAYS, dateTimeHTMLPickerStartDateTime );
  const maxDateTimePicker = TimeService.convertDateTimeStringToDateTimeHTMLPicker( maxDateTimePickerISO8601 );
  
  return (
    <form className="coaching_my-bookings_modify_modal_form white-bg">
      <h2 className="coaching_my-bookings_modify_modal_header">Modify {cardType}</h2>

      <div className="coaching_my_bookings_modify_modal_details">
        <span className="highlight-color-text">Tutoring</span> on <span className="highlight-color-text">{formattedDateTimeStartString}</span>
      </div>

      <div className="coaching_my_bookings_modify_modal_modifications_container">
        <div className="coaching_my_bookings_modify_modal_modifications_start-date-time">
          <label htmlFor="modify-reason"><strong>Start Date / Time: </strong></label>
          <input type="datetime-local" value={newStartDateTime} onChange={(e) => setNewStartDateTime(e.target.value)} min={minDateTimePicker} max={maxDateTimePicker} required />
        </div>
      </div>

      <div className="coaching_my_bookings_modify_modal_reason">
        <label htmlFor="modify-reason"><strong>Reason: </strong></label>
        <input type="text" value={modifyReason} onChange={(e) => handleUpdateModifyReason(e.target.value)} required />
      </div>

      <button className="coaching_my-bookings_section_card_details_manage-button persian-red-bg white-text" type="button" onClick={() => handleModify()}>Confirm</button>
    </form>
  );
}

interface CancelAppointmentModalProps {
  startDateTimeString: string,

  cancelType: string, // TODO: TYPE PROPERLY (ENUM?)

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
function CancelAppointmentModal( { startDateTimeString, cancelType, closeModalHandler }: CancelAppointmentModalProps ) {

  const navigate = useNavigate();

  const { selectedEventId: eventId } = useCoachingSchedule();
  //const { selectedRecurringInstance: recurringInstance } = useCoachingSchedule();

  /* NOTE:
     - When delete full Appointment (e.g. last Recurring Instance, leading to full Appointment being deleted in Database)
     ... -> DOES NOT REMOVE LISTED Appointment in UI (BookedAppointmentCard in AppointmentSection)
     ... -> IDEA: Can prob use CONTEXT and have useEffect on some variable/context that this Cancel Appointment would call, and if it's the last recurringEventInstanceId, then delete that Appointment from the list of Appointments got back from Server ... ?
  */

  const [ cancelReason, setCancelReason ] = useState<string>("");

  const handleUpdateCancelReason = ( updatedCancelReason: string ) => {
    setCancelReason( updatedCancelReason ); // TODO: Research which is better (for React specifically. I see some suggest currentTarget due to how Events bubble???)
  }

  const handleCancel = async () => {

    if( eventId == null ) {
      // TODO: ERROR HANDLE
      console.error( "Event ID Not Found - Cannot Cancel" );
      return;
    }

    //const cancelEventEndpoint = `/api/v1/coaching/schedule/events/${selectedEventId}`;
    const cancelEventEndpoint = `/api/v1/coaching/schedule/events/${eventId}`;

    const requestBody = {
      cancelType: cancelType,

      cancelReason: cancelReason,
    }

    const result = await fetch( cancelEventEndpoint, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( requestBody ),
    });

    if( result == null || !result.ok ) { // TODO: Other/better ERROR HANDLING (?)
      console.error( `ERROR Deleting ${cancelType}`, result.status)
    }

    //const responseBody = await result.json();

    closeModalHandler( null, true ); // TODO: What if CANCEL is not successful, handle differently?

    // TODO: Update client-side eventInstances state and do navigate(".", {replace: true }) instead (client-side component refresh instead of full-on reload)
    // ... Adding few second delay to give server time to modify/cancel event
    setTimeout( () => navigate(0), 4000 ); // Refresh the page to reflect the changes
  }


  //const startDateTimeString = eventId.split( "_" )[1]; // TODO: ERROR HANDLE - UGLY (better way...?) & not so efficient
  //const startDateTimeString = recurringInstance.dateTimeString;
  const formattedDateTimeStartString = TimeService.convertDateTimeStringToFormattedString( startDateTimeString ); // TODO: INEFFICIENTLY DONE AGAIN HERE AS DONE IN LISTING APPOINTMENT INSTANCES IN PARENT COMPONENTS...


  
  return (
    <form className="coaching_my-bookings_cancel_modal_form white-bg">
      <h2 className="coaching_my-bookings_cancel_modal_header">Cancel {cancelType}?</h2>

      <div className="coaching_my_bookings_cancel_modal_details">
        <span className="highlight-color-text">Tutoring</span> on <span className="highlight-color-text">{formattedDateTimeStartString}</span>
      </div>

      <div className="coaching_my_bookings_cancel_modal_reason">
        <label htmlFor="cancel-reason">Reason:</label>
        <input type="text" value={cancelReason} onChange={(e) => handleUpdateCancelReason(e.target.value)} required />
      </div>

      <button className="coaching_my-bookings_section_card_details_manage-button persian-red-bg white-text" type="button" onClick={() => handleCancel()}>Cancel</button>
    </form>
  )
}



interface ArtifactsModalProps {
  appointment: any, // TODO: TYPE

  cardType: string, 

  closeModalHandler: any, // TODO: TYPE PROPERLY... ?
}
function ArtifactsModal( { appointment, cardType, closeModalHandler }: ArtifactsModalProps ) {
  const googleDriveHomeLink = appointment?.googleDrive?.rootFolder.link;
  const metaSessionInfoLink = appointment?.googleDrive?.metaSessionInfo.link;
  const sessionsFolderLink = appointment?.googleDrive?.sessionsFolder.link;


  const openLink = (link: string) => {
    window.open(link, "_blank");

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to Shared Repo
      interactionDetails: {
        elementId: `modal_block_button`,
      },
      additionalDetails: {
        serviceType: appointment.service,
        appointmentStatus: appointment.status,

        appointmentType: appointment.appointmentType,
        startDateTimeString: appointment.startDateTime,

        link: link,
      },
    });
  }


  return (
    <>
      <div onClick={closeModalHandler} className="screen-overlay"></div>
      <form className="coaching_my-bookings_cancel_modal_form white-bg">
        <h2 className="coaching_my-bookings_cancel_modal_header">Program Artifacts</h2>

        { googleDriveHomeLink ? <button className="modal_block_button tamarillo-bg" type="button" onClick={() => openLink(googleDriveHomeLink)}>Google Drive Home</button> : <p>No Google Drive Home Link Yet</p> }
        { metaSessionInfoLink ? <button className="modal_block_button brand-bg" type="button" onClick={() => openLink(metaSessionInfoLink)}>Meta-Session Info</button> : <p>No Meta-Session Info Link Yet</p> }
        { sessionsFolderLink ? <button className="modal_block_button japanese-laurel-bg" type="button" onClick={() => openLink(sessionsFolderLink)}>Session Notes</button> : <p>No Session Notes Link Yet</p> }
      </form>
    </>
  );
}



interface PastAppointmentCardProps {
  appointment: any, // TODO: TYPE
  timezone: string,
}
function PastAppointmentCard({ appointment, timezone }: PastAppointmentCardProps ) {

  const startDateTimeString = appointment?.startDateTime;
  const formattedDateTimeStartString = TimeService.convertDateTimeStringToFormattedString( startDateTimeString );

  const googleDriveHomeLink = appointment?.googleDrive?.rootFolder.link;
  const metaSessionInfoLink = appointment?.googleDrive?.metaSessionInfo.link;
  const sessionsFolderLink = appointment?.googleDrive?.sessionsFolder.link;

  const subject = appointment?.subject ? fromCamelCaseToCapitalizedSpaced( appointment?.subject ) : undefined;
  const topic = appointment?.topic ? fromCamelCaseToCapitalizedSpaced( appointment?.topic ) : undefined;
  const service = appointment?.service ? fromCamelCaseToCapitalizedSpaced( appointment?.service ?? "Tutoring" ) : undefined;

  let formattedSubjectTopicJSX = <></>;
  if( subject || topic ) {
    const separator = subject && topic ? "|" : "";
    formattedSubjectTopicJSX = (
      <>
        for {subject && <span className="highlighted-bold-text">{subject}</span>}
        {separator}
        {topic && <span className="highlighted-bold-text">{topic}</span>}
      </>
    )
  }

  const openLink = (link: string) => {
    window.open(link, "_blank");

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to Shared Repo
      interactionDetails: {
        elementId: `modal_block_button`,
      },
      additionalDetails: {
        serviceType: appointment.service,
        appointmentStatus: "Past",

        appointmentType: appointment.appointmentType,
        startDateTimeString: appointment.startDateTime,

        link: link,
      },
    });
  }

  return (
    <div className="coaching_my-bookings_section_card alto-bg">
      <h4 className="coaching_my-bookings_section_card_header" style={{"margin": "0"}}>
        {/*<span className="highlighted-bold-text">{service}</span> service for <span className="highlighted-bold-text">{subject}</span>|<span className="highlighted-bold-text">{topic}</span><br/> on <span className="highlighted-bold-text">{formattedDateTimeStartString}</span>*/}
        <span className="highlighted-bold-text">{service}</span> service {formattedSubjectTopicJSX}<br/> on <span className="highlighted-bold-text">{formattedDateTimeStartString}</span>

        <div className="coaching_my-bookings_section_card_horizontal_artifacts">
          { googleDriveHomeLink ? <button className="modal_inline_button tamarillo-bg" type="button" onClick={() => openLink(googleDriveHomeLink)}>Google Drive Home</button> : <></> }
          { metaSessionInfoLink ? <button className="modal_inline_button brand-bg" type="button" onClick={() => openLink(metaSessionInfoLink)}>Meta-Session Info</button> : <></> }
          { sessionsFolderLink ? <button className="modal_inline_button japanese-laurel-bg" type="button" onClick={() => openLink(sessionsFolderLink)}>Session Notes</button> : <></> }
        </div>
      </h4>
    </div>
  );
}



function PreferencesOption() {

  return (
    <>
      <PreferencesContentHeader />
      <PreferencesContentBody />
    </>
  );
}

function PreferencesContentHeader() {

  return (
    <ContentHeader />
  );
}

function PreferencesContentBody() {

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="">
      {
        isAuthorized ?
          <>
            <FeatureComingSoon />
          </>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }

    </div>
  );
}




/* ======================================================================= */
/* =============================== Offers ================================ */
/* ======================================================================= */


/* =========================== Offers Overview =========================== */
function OffersOverview() {

  return (
    <OverviewOptions />
  );
}

/* =========================== Offers Content =========================== */
function OffersContent() {
  return (
    <>
      <FeatureComingSoon />
    </>
  );
}



/* ========================================================================== */
/* =============================== Portfolio ================================ */
/* ========================================================================== */


/* =========================== Portfolio Overview =========================== */

/* NOTE -- IDEAS FOR THIS SECTION (Business Ideas)
- Have a "Skills I Developed from this Project" section
  - E.g. THIS WHOLE PROJECT, AI4Youth, Artificial Artist (e.g. Shopify, Social Media, Scheduling, etc), ...
*/
function PortfolioOverview() {

  return (
    <OverviewOptions />
  );
}

/* =========================== Portfolio Content =========================== */
function PortfolioContent() {
  return (
    <>
      <FeatureComingSoon />
    </>
  );
}


/* ============================================================================= */
/* =============================== Testimonials ================================ */
/* ============================================================================= */


/* =========================== Testimonials Overview =========================== */
function TestimonialsOverview() {

  return (
    <OverviewOptions />
  );
}

/* =========================== Testimonials Content =========================== */
function TestimonialsContent() {

  const { selectedOption } = useCoaching();

  return (
    <>
      {renderTestimonialsContent( selectedOption )}
    </>
  );
}

function renderTestimonialsContent( selectedOption: string ) {

  switch( selectedOption ) {
    case "shareYourStory": {
      return <ShareYourStoryOption />
    }

    case "successSnapshots": {
      return <SuccessSnapshotsOption />
    }

    case "patternsOfSuccess": {
      return <PatternsOfSuccessOption />
    }

    default: {
      return <FeatureComingSoon />
    }
  }

}


function ShareYourStoryOption() {

  return (
    <>
      <ShareYourStoryContentHeader />
      <ShareYourStoryContentBody />
    </>
  );
}

function ShareYourStoryContentHeader() {

  return (
    <ContentHeader />
  );
}

function ShareYourStoryContentBody() {

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="">
      {
        isAuthorized ?
          <div className="coaching_share-your-story_content_container">
            {/*<div className="coaching_share-your-story_config">*/}
            <ShareYourStoryConfig />
            <ShareYourStoryTestimonial />
            <ShareYourStoryFooter />
          </div>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }

    </div>
  );
}

function ShareYourStoryConfig() {

  const { selectedService } = useCoaching();
  const { selectService } = useCoachingUpdate();

  const { selectedServiceHighlight } = useCoachingTestimonials();
  const { selectServiceHighlight } = useCoachingTestimonialsUpdate();

  return (
    <div className="coaching_share-your-story_content_config_container">
      <label className="coaching_share-your-story_content_config_label">Which service did you use?</label>
      <div className="coaching_share-your-story_config">
        <DropDownSelector selectorType={DropDownSelectorType.SERVICE} selectedOption={selectedService} selectorFunction={selectService} />
      </div>

      <label className="coaching_share-your-story_testimonial_label" htmlFor="testimonial">What stood out to you about our service?</label>
      <div className="coaching_share-your-story_config">
        <DropDownSelector selectorType={DropDownSelectorType.SERVICE_HIGHLIGHT} selectedOption={selectedServiceHighlight} selectorFunction={selectServiceHighlight} />
      </div>
    </div>
  );
}

function ShareYourStoryTestimonial() {

  const { testimonialText } = useCoachingTestimonials();
  const { updateTestimonialText } = useCoachingTestimonialsUpdate();

  const maxLengthTestimonial = 1200;

  return (
    <div className="coaching_share-your-story_testimonial_container">
      <label className="coaching_share-your-story_testimonial_label" htmlFor="testimonial">Please share some details about your experience...</label>
      <textarea id="testimonial" className="coaching_share-your-story_testimonial_text" value={testimonialText} onChange={(e) => updateTestimonialText(e.target.value)} maxLength={maxLengthTestimonial} required={true} />
      <div className="coaching_share-your-story_testimonial_footer">{testimonialText.length} / {maxLengthTestimonial} characters</div>
    </div>
  );
}

function ShareYourStoryFooter() {
  const { allowPublicShare } = useCoachingTestimonials();
  const { toggleAllowPublicShare } = useCoachingTestimonialsUpdate();

  const { submitTestimonial } = useCoachingTestimonialsUpdate();

  return (
    <div className="coaching_share-your-story_content_footer">
      <div className="coaching_share-your-story_content_footer_consent">
        <input id="public-share" type="checkbox" checked={allowPublicShare} onChange={toggleAllowPublicShare} />
        <label htmlFor="public-share">This testimonial can be publicly displayed</label>
      </div>

      <button className="coaching_share-your-story_content_footer_submit brand-bg white-text" type="button" onClick={submitTestimonial}>Submit</button>
    </div>
  );
}


function SuccessSnapshotsOption() {

  return (
    <>
      <SuccessSnapshotsContentHeader />
      <SuccessSnapshotsContentBody />
    </>
  );
}

function SuccessSnapshotsContentHeader() {

  return (
    <ContentHeader />
  );
}

function SuccessSnapshotsContentBody() {

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="">
      {
        isAuthorized ?
          <>
            <FeatureComingSoon />
          </>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }

    </div>
  );
}



function PatternsOfSuccessOption() {

  return (
    <>
      <PatternsOfSuccessContentHeader />
      <PatternsOfSuccessContentBody />
    </>
  );
}

function PatternsOfSuccessContentHeader() {

  return (
    <ContentHeader />
  );
}

function PatternsOfSuccessContentBody() {

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="">
      {
        isAuthorized ?
          <>
            <FeatureComingSoon />
          </>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }

    </div>
  );
}






/* ======================================================================== */
/* =============================== Contact ================================ */
/* ======================================================================== */


/* =========================== Contact Overview =========================== */
function ContactOverview() {

  return (
    <OverviewOptions />
  );

}

/* =========================== Contact Content =========================== */
function ContactContent() {

  const { selectedOption } = useCoaching();

  return (
    <>
      {renderContactContent( selectedOption )}
    </>
  );
}

function renderContactContent( selectedOption: string ) {

  switch( selectedOption ) {
    case "email": {
      return <EmailOption />
    }

    case "socials": {
      return <SocialsOption />
    }

    case "phone": {
      return <PhoneOption />
    }

    default: {
      return <FeatureComingSoon />
    }
  }

}


function EmailOption() {

  return (
    <>
      <EmailContentHeader />
      <EmailContentBody />
    </>
  );
}

function EmailContentHeader() {

  return (
    <ContentHeader />
  );
}

function EmailContentBody() {

  const { selectedSubject, selectedTopic } = useCoaching();
  const { selectSubject, selectTopic } = useCoachingUpdate();


  const [ emailSubject, setEmailSubject ] = useState( "" );
  const [ emailBody, setEmailBody ] = useState( "" );

  const maxLengthSubject = 80;
  const maxLengthBody = 1020;


  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <>
      {
        isAuthorized ?
          // TODO: Make this all separate Components
          <div className="coaching_email_content_container">

            <div className="coaching_email_content_config_container">
              <label className="coaching_email_content_config_label">Select the Subject and Topic relevant to your request:</label>
              <div className="coaching_book-now_config"> {/*TODO: Using same CSS Class -- Mainly testing! */}
                <DropDownSelector selectorType={DropDownSelectorType.SUBJECT} selectedOption={selectedSubject} selectorFunction={selectSubject} />
                <DropDownSelector selectorType={DropDownSelectorType.PROGRAM} selectedOption={selectedTopic} selectorFunction={selectTopic} />
              </div>
            </div>
            
            <div className="coaching_email_content_subject_container">
              <label className="coaching_email_content_subject_label" htmlFor="email-subject">Subject:</label>
              <input id="email-subject" className="coaching_email_content_subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} maxLength={maxLengthSubject} required={true} />
              <div className="coaching_email_content_subject_footer">{emailSubject.length} / {maxLengthSubject} characters</div>
            </div>

            <div className="coaching_email_content_body_container">
              <label className="coaching_email_content_body_label" htmlFor="email-body">Type your message...</label>
              <textarea id="email-body" className="coaching_email_content_body" value={emailBody} onChange={(e) => setEmailBody(e.target.value)} maxLength={maxLengthBody} required={true} />
              <div className="coaching_email_content_body_footer">{emailBody.length} / {maxLengthBody} characters</div>
            </div>

            <div className="coaching_email_content_footer">
              <button className="coaching_email_content_footer_submit brand-bg white-text" type="submit">Send</button>
            </div>

          </div>
        :
          <div className="locked-content">
            <LogInPromptContainer HeaderComponent={LockIcon} logInTo="access" description="This content is locked." />
          </div>
      }
    </>
  );
}


function SocialsOption() {

  return (
    <>
      <SocialsContentHeader />
      <SocialsContentBody />
    </>
  );
}

function SocialsContentHeader() {

  return (
    <ContentHeader />
  );
}

function SocialsContentBody() {

  const socials = [
    { name: "Twitter", description: "Regular dose of direct, concise, and punchy insights (short-mixed).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.TwitterIcon },
    { name: "TikTok", description: "Regular dose of direct, concise, and punchy insights (short-video).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.TikTokIcon },
    { name: "YouTube", description: "Regular dose of direct, concise, and punchy insights (mixed-video).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.YouTubeIcon },
    { name: "LinkedIn", description: "Regular dose of practical, story-based insights (mixed-content).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.LinkedInIcon },
    { name: "Instagram", description: "Regular dose of lifestyle and practical insights (short-mixed).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.InstagramIcon },
    { name: "Facebook", description: "Regular dose of direct, concise, and punchy insights (short-mixed).", link: "https://www.facebook.com/profile.php?id=100091483422164", icon: Socials.FacebookIcon },
  ];

  return (
    <div className="coaching_socials_content_container" >

      {socials.map( (social: any, index: number) => {
        return (
          <div className="coaching_socials_content" key={index}>
            <a href={social.link} >
              <social.icon />
              <div className="coaching_socials_content_text">
                <h3 className="coaching_socials_content_header">{social.name}</h3>
                <p className="coaching_socials_content_description">{social.description}</p>
              </div>
            </a>
          </div>
        );
      })}
      
    </div>
  );
}





function PhoneOption() {

  return (
    <>
      <PhoneContentHeader />
      <PhoneContentBody />
    </>
  );
}

function PhoneContentHeader() {

  return (
    <ContentHeader />
  );
}

function PhoneContentBody() {

  const { user } = useUser();
  const isAuthorized = user != null ? true : false; // Simple "Log In to View" Functionality (for now ??)


  return (
    <div className="">
      {
        false ? // Right now disabled
          <>
            <FeatureComingSoon />
          </>
        :
          <div className="locked-content">
            <GeneralLockedContentContainer HeaderComponent={LockIcon} alert="Requires a higher subscription" description="This content is locked." />
          </div>
      }

    </div>
  );
}


/* ======================================================================= */




/* =============================== COMMON ================================ */
function DropDownSelector( {selectorType, selectedOption, selectorFunction}: {selectorType: DropDownSelectorType, selectedOption: any, selectorFunction: any} ) {
  // TODO: Enforce Structure ... via <Generics>
  //const { programData, selectedFeature } = useProgram();
  //const { selectFeature } = useProgramUpdate();

  const { coachingData, programCoachingData, selectedSubject, subjects, topics } = useCoaching();

  let selectorItems: any[] = [];

  switch( selectorType ) {
    case DropDownSelectorType.SUBJECT: {
      selectorItems = subjects;

      break;
    }

    case DropDownSelectorType.PROGRAM: {
      selectorItems = topics[selectedSubject] ?? [];

      break;
    }

    case DropDownSelectorType.SESSION: {
      selectorItems = coachingData.appointmentTypes.map( (appointmentType: any) => { // TODO: TYPE appointmentType
        return appointmentType.name;
      });

      break;
    }

    case DropDownSelectorType.SERVICE: {
      if( programCoachingData ) {
        selectorItems = programCoachingData.offers.map( (offer: any) => { // TODO: TYPE
          return offer.serviceSelector;
        });
      }

      /* TODO: May be able remove services from coachingData and just use programCoachingData...?
      selectorItems = coachingData.services.map( (service: any) => { // TODO: TYPE service
        return service.selector;
      });
      */

      break;
    }

    case DropDownSelectorType.SERVICE_HIGHLIGHT: {
      selectorItems = coachingData.serviceHighlights.map( (highlight: any) => {
        return highlight.name;
      });

      break;
    }
  }

  return (
    <div className="coaching_drop-down_wrapper">
      <div className="coaching_drop-down_header">
        {/* TODO: Find more efficient way, may just create function to go from ENUM_CAPITALIZATION or whatever that is called (screamingSnakeCaseToCapitalizedSpace) to Capitalized Spaced */}
        <span>{fromCamelCaseToCapitalizedSpaced(toCamelCase(selectorType))}</span>
      </div>

      <div className="coaching_drop-down_container">
        <HamburgerMenu />

        <select onChange={(event) => selectorFunction(event.target.value)} value={selectedOption} className="coaching_drop-down ">
          {selectorItems.map( (item, index) => {
            // TODO: Find more efficient way to render Capitalized Spaced and not the camelCase values
            // ... Consider if this is much of a hit on performance, if not, then no problem
            // ... Also, consider renaming "subjects" and "topics", as they're now camelCased and that may not make sense for Variable name
            return <option value={item} key={index}>{fromCamelCaseToCapitalizedSpaced(item)}</option>
          })}

          <option value="MoreToCome" disabled>... More to Come! ...</option>
        </select>
      </div>
    </div>
  );
}

function OverviewOptions() { // TODO: Properly Type
  const { engagementOptions, selectedOption } = useCoaching();
  const { selectOption } = useCoachingUpdate();

  if( engagementOptions == null || engagementOptions.length == 0 ) return <div><FeatureComingSoon /></div>;

  return (
    <div className="platform_aside_overview_info_nav_container">
      <ol className="platform_aside_overview_info_nav_list">
        {engagementOptions.map( (option: IEngagementOption, index: number) => {
          return <li onClick={() => selectOption(option.selector)} key={index} className={`platform_aside_overview_info_nav_list_button ${option.selector == selectedOption ? "active" : ""}`}>
                    {option.name}
                 </li>
        })}
      </ol>
    </div>
  );
}


function ContentHeader() {
  const { optionContent } = useCoaching();

  if( !optionContent ) return <></>

  return (
    <div className="coaching_body_content_header">
      <h2 className="coaching_body_content_header_title">{optionContent.name}</h2>
    </div>
  );
}

/* ======================================================================= */



/* ======================== GENERAL COMPONENTS =========================== */

// TODO: Move elsewhere, such as Common Components ?? ('common' folder)
interface VenmoProps {
  amountPay: number,
  note: string,
}
const VenmoButton = ( {amountPay, note}: VenmoProps ) => {
  const handleVenmoPay = () => {
    const amount = String(amountPay);
    const recipient = "Brandon-Test"; // TODO: Make my actual account
    const noteURLEncoded = encodeURIComponent( note ); // Encodes a seciton of URI (assumes input needs be treated as all needing ot be encoded) - Vs encodeURI which will take in a URL and encodes it to be properly URL Encoded
    const venmoURL = `https://account.venmo.com/pay?amount=${amount}&note=${noteURLEncoded}&recipients=${recipient}&txn=pay`;

    window.open( venmoURL, "_blank" );
  };

  return (
    <button className="modal_block_button azure-radiance-bg white-text" onClick={handleVenmoPay}>Venmo Pay</button>
  );
}

const PayPalButton = () => {
  const handlePayPalPay = () => {
    const recipient = "BrandonJones77";
    const payPalURL = `https://paypal.me/${recipient}`;

    window.open( payPalURL, "_blank" );
  };

  return (
    <button className="modal_block_button sunglow-bg white-text" onClick={handlePayPalPay}>PayPal Pay</button>
  );
}

/* ======================================================================= */



/* =============================== HELPERS =============================== */

// TODO: MOVE TO SHARED REPO TimeService (repeated in CoachingAppointmentModalContext.tsx)
function convertTo12HourFormat( time24: string ) {
  const [ hours, minutes ] = time24.split(":").map( num => parseInt(num, 10) );
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12; // If already 12th hour, keep it, i.e. if % = 0

  const zeroBasedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours12}:${zeroBasedMinutes} ${period}`;
}

interface RetrieveCoachingAvailabilityParams {
  organizeBy: string, 
  recurringOnly?: boolean, 

  abortSignal: AbortSignal,
}
async function retrieveCoachingAvailability( {organizeBy, recurringOnly = false, abortSignal}: RetrieveCoachingAvailabilityParams ) {
  try {
    const organizedAvailabilityData = await fetchCoachingAvailability( {organizeBy: organizeBy, recurringOnly: recurringOnly, signal: abortSignal} );

    return organizedAvailabilityData;
  } catch(error) {
    console.error(`ERROR fetching Coaching Availability by ${organizeBy}`, error);
    return;
  }
}

function getDayTimesFormattedStringFromRecurringConfig( recurringConfig: any ) { // TODO: TYPE
  // TODO: ... CONSIDER ERROR HANDLING (just made function for quick-generality)

  // TODO: THIS FUNCTIONALITY REPEATED ON FRONTEND AS WELL (for BookedAppointmentCard's Date/Time UI section)
  // ... This is only place with this as a Helper Function, though -- SO USE THIS when generalizing for Frontend & Backend

  // TODO: Revisit whether can just be sure to not set recurringConfig.dayTimes fields to anything if there is no date/time for it (don't remember why I had to make non-checked days empty strings...?)
  // ... Need to do this filter here for now though, since checking array.length to determine if add '&' at end of a day/time
  const dayTimes = recurringConfig.dayTimes;
  const daysSelected = Object.keys(dayTimes).filter( (day: string) => dayTimes[day] );

  let dayTimesFormatted: string = "";

  //const daysOfWeek: string[] = [];
  daysSelected.forEach( (dayOfWeek: string, index: number, array: any) => {
    if( dayOfWeek ) {
      //const dayOfWeek = TimeService.getDayOfWeekFromDate( dayTimes[day] );
      //daysOfWeek.push( dayOfWeek );
      //daysOfWeek.push( day ); // TODO: Will be lowercase at the moment...

      // TODO: MOVE TO SHARED REPO TimeService (repeated in Client Code too, like Coaching.tsx & CoachingAppointmentModalContext.tsx)
      const { time24 } = TimeService.extractDateTimeISO8601Components( dayTimes[dayOfWeek] );
      const time12 = convertTo12HourFormat( time24 );

      const capitalizedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

      //const timezoneAbbreviation = TimeService.getTimezoneAbbreviation( dayTimes[dayOfWeek], "America/Denver" );
      dayTimesFormatted += `${capitalizedDayOfWeek}s (${time12})${index+1 < array.length 
                              ?
                                " & "
                              :
                                ` ${TimeService.getTimezoneAbbreviation(dayTimes[dayOfWeek], "America/Denver")}` // TODO: Can remove "America/Denver" once latest changes to Shared Repo are pushed since has .guess() for Timezone now
                            }`;
    }
  });

  return dayTimesFormatted;
}
/* ======================================================================= */





export {
  Coaching,
  ScheduleOverview, ScheduleContent
};



/* */
